<template>
  <v-card
    height="100%"
    width="100%"
    :outlined="displayMobile ? false : true"
    :tile="displayMobile ? true : false"
  >
    <v-btn
      v-if="!displayMobile"
      fab
      absolute
      dark
      small
      color="#00000096"
      @click.stop="$emit('closeDestinationPage')"
      alt="close Destination Page"
      style="top:16px; right:16px"
    >
      <v-icon small>close</v-icon>
    </v-btn>
    <!-- HEADER MOBILE AND TABLET -->
    <v-app-bar
      v-if="displayMobile"
      dark
      :src="destinationPicture"
      flat
      :height="toolbarHeight"
      style="transition:height 0.3s ease-in-out"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="#104f5596, #ffffff00"
          style="transition:height 0.3s ease-in-out"
        ></v-img>
      </template>
      <v-btn
        fab
        dark
        small
        class="mr-4"
        color="#00000096"
        @click.stop="$emit('closeDestinationPage')"
        alt="close Destination Page"
        style="top:-16px; transition:all 0.3s ease-in-out"
      >
        <v-icon small>close</v-icon>
      </v-btn>
      <v-toolbar-title
        v-text="destination.name"
        class="pacifico-family relative text-h4"
        :style="toolbarInformationStyle + ';transition:top 0.3s ease-in-out'"
      ></v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>
    <!-- DESTINATION CONTENT -->
    <v-sheet
      class="scroll--overflow-y thin-scrollbar"
      :style="
        displayMobile
          ? mobileDestinationContentStyle
          : desktopDestinationContentStyle
      "
      id="scroll-target"
      v-scroll:#scroll-target="onScroll"
      v-bind:class="{
        'rounded-t-8 relative top-shadow pa-8 pa-4 px-0': displayMobile
      }"
    >
      <!-- HEADER DESKTOP -->
      <div v-if="!displayMobile">
        <v-row no-gutters>
          <v-col cols="6">
            <BaseSheet color="grey lighten-1">
              <v-img :src="destinationPicture" height="194" cover></v-img>
            </BaseSheet>
          </v-col>
          <v-col cols="6" class="relative pa-4 d-flex flex-wrap">
            <div class="full--width">
              <!-- SHORTNAME DESTINATION -->
              <div class="d-flex align-center">
                <v-icon color="primary" class="mr-2">
                  {{ `$${destination.category.nameEn}` | noSpace }}
                </v-icon>
                <span v-text="destination.name" class="text-h6"></span>
              </div>
              <!-- DEPARTMENT DESTINATION -->
              <div
                v-text="destination.location.properties.department"
                class="text-body-1 grey--text text--darken-1 font-weight-medium text-uppercase"
              ></div>
            </div>
            <!-- DISTANCE -->

            <div class="align-self-end">
              <SearchDestinationPageDistanceInformation
                v-if="
                  searchParams.longName !=
                    destination.location.properties.longName &&
                    destination.distance !== null
                "
                :distance="destination.distance"
                :routeUrl="destination.routeUrl"
                class="align-self-end mb-2"
              ></SearchDestinationPageDistanceInformation>
              <v-btn
                :href="destination.routeUrl"
                target="blank"
                depressed
                small
                text
                color="primary"
                outlined
                v-text="$t('search.destination.routeFromMyPosition')"
              >
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </div>
      <!-- Explorations Section -->
      <v-sheet>
        <!-- Destination Title for Mobile Display -->
        <div class="mx-8" v-if="displayMobile">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">
              {{ `$${destination.category.nameEn}` | noSpace }}
            </v-icon>
            <span v-text="destination.name" class="text-h6"></span>
          </div>
          <div
            v-text="destination.location.properties.department"
            class="text-body-1 grey--text text--darken-1 font-weight-medium text-uppercase"
          ></div>
          <!-- DISTANCE -->
          <SearchDestinationPageDistanceInformation
            v-if="
              searchParams.longName !=
                destination.location.properties.longName &&
                destination.distance !== null
            "
            :distance="destination.distance"
            :routeUrl="destination.routeUrl"
            class="mt-2"
          ></SearchDestinationPageDistanceInformation>
          <v-btn
            :href="destination.routeUrl"
            target="blank"
            depressed
            text
            color="primary"
            outlined
            v-text="$t('search.destination.routeFromMyPosition')"
            class="mt-2"
          >
          </v-btn>
          <v-divider class="mt-8"></v-divider>
        </div>

        <!-- Exploration title -->
        <div class="text-center pt-4">
          <span
            v-text="$t('app.plural_EXPERIENCE')"
            class="text-uppercase text-subtitle-1 font-weight-medium mx-3 grey--text text--darken-3"
          >
          </span>
        </div>
        <!-- Exploration searchFilter -->
        <!-- Waiting to have more experience in a destination to show filters -->
        <!-- <v-sheet
          color="white"
          elevation="0"
          class="sticky"
          :style="`${displayMobile ? 'top:-32px' : 'top:0px'}; z-index:3`"
        >
          
          <SearchDestinationPageFilters
            @updateParameter="newSearchPostsInDestination"
            :searchParams="searchPostsInDestinationParams"
            :displayMobile="displayMobile"
            class="pt-4 px-8"
          ></SearchDestinationPageFilters>
          <v-divider></v-divider>
        </v-sheet> -->
        <!-- POST RESULTS -->
        <div class="my-4 mx-1">
          <!-- LOADING POST STATE -->
          <v-row v-if="loadingPosts" no-gutters>
            <v-col
              v-for="n in destination.totalPostsCount"
              :key="n"
              :cols="destinationPageResponsiveColPost"
              class="px-1 pb-1"
            >
              <BasePostCardLoading></BasePostCardLoading>
            </v-col>
          </v-row>
          <!-- DISPLAY POST STATE -->
          <div v-else-if="searchPostsInDestination.posts.length > 0">
            <v-row no-gutters>
              <v-col
                v-for="post in searchPostsInDestination.posts"
                :key="post.id"
                :cols="destinationPageResponsiveColPost"
                class="px-1 pb-2"
              >
                <BaseExperienceCard :post="post"></BaseExperienceCard>
              </v-col>
            </v-row>
            <!-- More posts button -->
            <div
              v-if="
                destination.postsCount > searchPostsInDestination.posts.length
              "
              class="d-flex justify-center"
            >
              <v-btn
                @click="addSearchPostsInDestination()"
                depressed
                class="my-4"
                color="secondary"
                :loading="loadingAddPosts"
                >Voir plus</v-btn
              >
            </div>
            <!-- Display experiences suggestion for a username -->
            <div
              v-if="
                searchParams.username &&
                  destination.postsCount <=
                    searchPostsInDestination.posts.length &&
                  destination.creatorTotalPostsCount !==
                    destination.postsCount &&
                  destination.creatorTotalPostsCount !==
                    searchPostsInDestination.posts.length
              "
              class="pa-4"
            >
              <v-divider class="mb-4"></v-divider>
              <div class="full--width text-center mb-2">
                <v-btn
                  @click="addSuggestionSearchPostInDestination()"
                  :loading="loadingAddPosts"
                  color="primary"
                  text
                  outlined
                >
                  {{ $t("search.destination.destinationSeeMoreWithoutFilter") }}
                </v-btn>
              </div>
              <div class="text-center text-caption secondary-text">
                {{
                  destination.creatorTotalPostsCount -
                    searchPostsInDestination.posts.length
                }}
                {{
                  destination.creatorTotalPostsCount -
                    searchPostsInDestination.posts.length ===
                  1
                    ? $t("search.destination.singular_OTHER_EXPERIENCE")
                    : $t("search.destination.plural_OTHER_EXPERIENCE")
                }}
              </div>
            </div>
            <!-- Display experiences suggestion -->
            <div
              v-if="
                !searchParams.username &&
                  destination.postsCount <=
                    searchPostsInDestination.posts.length &&
                  destination.totalPostsCount !== destination.postsCount &&
                  destination.totalPostsCount !==
                    searchPostsInDestination.posts.length
              "
              class="pa-4"
            >
              <v-divider class="mb-4"></v-divider>
              <div class="full--width text-center mb-2">
                <v-btn
                  @click="addSuggestionSearchPostInDestination()"
                  :loading="loadingAddPosts"
                  color="primary"
                  text
                  outlined
                >
                  {{ $t("search.destination.destinationSeeMoreWithoutFilter") }}
                </v-btn>
              </div>
              <div class="text-center text-caption secondary-text">
                {{
                  destination.totalPostsCount -
                    searchPostsInDestination.posts.length
                }}
                {{
                  destination.totalPostsCount -
                    searchPostsInDestination.posts.length ===
                  1
                    ? $t("search.destination.singular_OTHER_EXPERIENCE")
                    : $t("search.destination.plural_OTHER_EXPERIENCE")
                }}
              </div>
            </div>
          </div>
          <!-- DISPLAY NO POST STATE -->
          <div v-else class="text-center">
            <span v-text="$t('search.noPosts')" class="text-h6"></span>
          </div>
        </div>
      </v-sheet>
    </v-sheet>
  </v-card>
</template>

<script>
// COMPONENTS
import BaseExperienceCard from "../../core/components/BaseExperienceCard";
import BasePostCardLoading from "../../core/components/BasePostCardLoading";
import SearchDestinationPageDistanceInformation from "./SearchDestinationPageDistanceInformation";

// SERVICES
import SearchParamsService from "../services/SearchParamsService";
import SearchService from "../services/SearchService";

export default {
  name: "SearchDestinationPage",
  components: {
    BaseExperienceCard,
    BasePostCardLoading,
    SearchDestinationPageDistanceInformation
  },
  // DATA
  props: {
    destination: {
      type: Object,
      required: true
    },
    searchParams: {
      type: Object,
      required: true
    },
    displayMobile: {
      type: Boolean,
      default: () => false
    },
    destinationPageResponsiveColPost: {
      type: String,
      default: () => "12"
    }
  },
  // COMPUTED
  computed: {
    // coment until next version
    toolbarHeight() {
      return "96px";
      //return 194 - this.offsetTop / 2 > 96 ? "194px" : "96px";
    },
    toolbarInformationStyle() {
      return "top: -16px";
      //return 96 - this.offsetTop / 1.5 > -16 ? "top:96px" : "top: -16px";
    },
    mobileDestinationContentStyle() {
      return "height: calc( 100% - 96px + 32px); top:-32px";
      //return 194 - this.offsetTop / 2 > 96
      //  ? `height: calc( 100%  + 32px); top:-32px`
      //  : "height: calc( 100% - 96px + 32px); top:-32px";
    },
    desktopDestinationContentStyle() {
      return `height: 100%`;
    },
    destinationId() {
      return this.destination.id;
    },
    destinationPicture() {
      if (this.destination.mainPicture)
        return this.$vuetify.breakpoint.xs
          ? this.destination.mainPicture.small
          : this.destination.mainPicture.medium;
      return require("@/assets/defaultCardPicture.png");
    }
  },
  // DATA
  data() {
    return {
      loadingPosts: false,
      loadingAddPosts: false,
      searchPostsInDestination: [],
      searchPostsInDestinationParams: {},
      offsetTop: 0
    };
  },
  // METHODS
  methods: {
    initiateFirstSearchPostsInDestinationParams() {
      this.searchPostsInDestinationParams = SearchParamsService.getDestinationSearchParams(
        { ...this.searchParams, page: 1 },
        this.destination.id
      );
    },
    getSearchPostsInDestination() {
      this.loadingPosts = true;
      SearchService.getDestinationSearchPosts(
        this.searchPostsInDestinationParams
      )
        .then(posts => {
          this.searchPostsInDestination = posts;
        })
        .catch()
        .finally(() => (this.loadingPosts = false));
    },
    newSearchPostsInDestination(newParameter) {
      this.loadingPosts = true;
      this.searchPostsInDestinationParams = SearchParamsService.getSearchPostsInDestinationParams(
        this.searchPostsInDestinationParams,
        newParameter,
        this.destination.id
      );
      SearchService.getDestinationSearchPosts(
        this.searchPostsInDestinationParams
      )
        .then(searchPostsInDestination => {
          this.searchPostsInDestination = searchPostsInDestination;
        })
        .catch()
        .finally(() => (this.loadingPosts = false));
    },
    // Push Posts to the Posts Array of SearchInDestination
    addSearchPostsInDestination() {
      this.loadingAddPosts = true;
      this.searchPostsInDestinationParams = SearchParamsService.addSearchPostsInDestination(
        this.searchPostsInDestinationParams
      );
      SearchService.getDestinationSearchPosts(
        this.searchPostsInDestinationParams
      )
        .then(searchPostsInDestination => {
          this.searchPostsInDestination.posts = [
            ...this.searchPostsInDestination.posts,
            ...searchPostsInDestination.posts
          ];
        })
        .catch()
        .finally(() => (this.loadingAddPosts = false));
    },
    addSuggestionSearchPostInDestination() {
      this.loadingAddPosts = true;
      // Set new search params
      this.searchPostsInDestinationParams = SearchParamsService.addSuggestionSearchPostInDestination(
        this.searchPostsInDestinationParams,
        this.searchPostsInDestination.posts.map(post => post.nameId)
      );
      SearchService.getDestinationSearchPosts(
        this.searchPostsInDestinationParams
      )
        .then(searchPostsInDestination => {
          this.searchPostsInDestination.posts = [
            ...this.searchPostsInDestination.posts,
            ...searchPostsInDestination.posts
          ];
        })
        .catch()
        .finally(() => (this.loadingAddPosts = false));
    },
    getFontSizeClass(length) {
      switch (true) {
        case length < 15:
          return "text-h2";
        case length < 20:
          return "text-h3";
        case length < 30:
          return "text-h4";
      }
    },
    onScroll(event) {
      this.offsetTop = event.target.scrollTop;
    }
  },
  // WATCH
  watch: {
    destinationId() {
      this.initiateFirstSearchPostsInDestinationParams();
      this.getSearchPostsInDestination();
    }
  },
  // LIFE CYCLE HOOKS
  created() {
    this.initiateFirstSearchPostsInDestinationParams();
    this.getSearchPostsInDestination();
  }
};
</script>

<style scoped>
.top-shadow {
  -webkit-box-shadow: 0px -5px 3px rgba(60, 64, 67, 0.3);
  -moz-box-shadow: 0px -5px 3px rgba(60, 64, 67, 0.3);
  box-shadow: 0px -5px 3px rgba(60, 64, 67, 0.3);
}
</style>
